export default __webpack_public_path__ + "static/media/Homepage_wbFF-05.c00c0e0b.png";